/**
 * ------------------------------------------------------------------------
 * HEADER STICKY JS
 * ------------------------------------------------------------------------
 */

document.addEventListener('DOMContentLoaded', function() {

    /**
     * Variables
     *
     * @type {{gapScroll: number, header: *, stickyClass: string}}
     */
    var configHeaderSticky = {
        gapScroll: 1,
        header: document.getElementsByClassName('header')[0],
        stickyClass: 'header_sticky'
    };

    /**
     * Init
     */
    if(document.getElementsByClassName('header')[0]) {
        window.addEventListener('scroll', stickyStart, true);
    }

    /**
     * Function stickyStart
     *
     * Check if the scrolling has started and apply the class to the header
     */
    function stickyStart() {
        if(window.pageYOffset > configHeaderSticky.gapScroll) {
            configHeaderSticky.header.classList.add(configHeaderSticky.stickyClass);

            $('.header__logo').find('.st0_1').addClass('st0');
            window.removeEventListener('scroll', stickyStart, true);
            window.addEventListener('scroll', stickyStop, true);
        }
    }

    /**
     * Function stickyStop
     *
     * Check if the scrolling has stopped and remove the class to the header
     */
    function stickyStop() {
        if(window.pageYOffset <= configHeaderSticky.gapScroll) {
            configHeaderSticky.header.classList.remove(configHeaderSticky.stickyClass);

            $('.header__logo').find('.st0_1').removeClass('st0');
            window.removeEventListener('scroll', stickyStop, true);
            window.addEventListener('scroll', stickyStart, true);
        }
    }
});












// /**
//  * ------------------------------------------------------------------------
//  * HEADER STICKY JS (con gestione della classe "isShow" su .customTimeline + badgeStep)
//  * ------------------------------------------------------------------------
//  */
//
// document.addEventListener('DOMContentLoaded', function() {
//
//     /**
//      * Variables
//      */
//     var configHeaderSticky = {
//         gapScroll: 1,
//         header: document.querySelector('.header'),
//         stickyClass: 'header_sticky',
//         timeline: document.querySelector('.customTimeline'),
//         badgeSteps: document.querySelectorAll('.badgeStep') // Seleziona tutti gli elementi con classe .badgeStep
//     };
//
//     /**
//      * Init
//      */
//     if (configHeaderSticky.header) {
//         window.addEventListener('scroll', stickyStart, true);
//         window.addEventListener('scroll', checkBadgeSteps, true);
//     }
//
//     /**
//      * Function stickyStart
//      *
//      * Applica la classe sticky all'header e aggiorna la timeline
//      */
//     function stickyStart() {
//         if (window.pageYOffset > configHeaderSticky.gapScroll) {
//             configHeaderSticky.header.classList.add(configHeaderSticky.stickyClass);
//
//             if (configHeaderSticky.timeline) {
//                 configHeaderSticky.timeline.classList.add('isShow');
//             }
//
//             $('.header__logo').find('.st0_1').addClass('st0');
//             window.removeEventListener('scroll', stickyStart, true);
//             window.addEventListener('scroll', stickyStop, true);
//         }
//     }
//
//     /**
//      * Function stickyStop
//      *
//      * Rimuove la classe sticky dall'header e aggiorna la timeline
//      */
//     function stickyStop() {
//         if (window.pageYOffset <= configHeaderSticky.gapScroll) {
//             configHeaderSticky.header.classList.remove(configHeaderSticky.stickyClass);
//
//             if (configHeaderSticky.timeline) {
//                 configHeaderSticky.timeline.classList.remove('isShow');
//                 configHeaderSticky.timeline.className = configHeaderSticky.timeline.className.replace(/\bcustomTimeline_step_\d+\b/g, '');
//             }
//
//             $('.header__logo').find('.st0_1').removeClass('st0');
//             window.removeEventListener('scroll', stickyStop, true);
//             window.addEventListener('scroll', stickyStart, true);
//         }
//     }
//
//     /**
//      * Function checkBadgeSteps
//      *
//      * Controlla quali .badgeStep sono nella viewport e aggiorna le classi
//      */
//     function checkBadgeSteps() {
//         configHeaderSticky.badgeSteps.forEach(function (badge) {
//             var rect = badge.getBoundingClientRect();
//             var badgeNumber = badge.getAttribute('data-badge');
//
//             if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
//                 badge.classList.add('in-view');
//
//                 if (configHeaderSticky.timeline) {
//                     configHeaderSticky.timeline.className = configHeaderSticky.timeline.className.replace(/\bcustomTimeline_step_\d+\b/g, '');
//                     configHeaderSticky.timeline.classList.add('customTimeline_step_' + badgeNumber);
//                 }
//             } else {
//                 badge.classList.remove('in-view');
//             }
//         });
//     }
// });
